import { FC } from 'react';
import { Typography } from '@mui/material';

import Modal from 'components/common/Modal';
import FingerPrint from 'components/common/icons/FingerPrint';
import { translate } from 'utils/translate';

interface IBiometricLoginPopupProps {
  onClose: () => void;
  onSave: () => void;
}

const BiometricLoginPopup: FC<IBiometricLoginPopupProps> = ({ onClose, onSave }) => {
  return (
    <Modal
      title="Do you want to enable biometric login?"
      icon={<FingerPrint />}
      saveText="Enable"
      onSave={onSave}
      onClose={onClose}
      maxWidth={400}
    >
      <Typography>{translate('Do you want to enable biometric login?')}</Typography>
    </Modal>
  );
};

export default BiometricLoginPopup;
